module.exports = __webpack_public_path__ + "img/bcc355.97d0d254.jpeg";